"use strict";

/**
 * AJAX pagination for the list-collections page.
 * Uses Shopify Section Rendering API so the page does not full-reload or jump.
 */
(function () {
  var SELECTOR = "[data-collections-ajax]";

  function buildSectionUrl(href, sectionId) {
    var url = new URL(href, window.location.origin);
    url.searchParams.set("section_id", sectionId);
    return url.toString();
  }

  function getContent(root) {
    return root.querySelector("[data-collections-content]");
  }

  function showLoader(root) {
    var loader = root.querySelector("[data-collections-loader]");
    if (!loader) return;
    loader.hidden = false;
    loader.setAttribute("aria-hidden", "false");
  }

  function hideLoader(root) {
    var loader = root.querySelector("[data-collections-loader]");
    if (!loader) return;
    loader.hidden = true;
    loader.setAttribute("aria-hidden", "true");
  }

  function replaceContent(root, html) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var next = doc.querySelector("[data-collections-content]");
    var current = getContent(root);
    if (!next || !current) return false;
    current.innerHTML = next.innerHTML;
    return true;
  }

  function loadPage(root, href, pushHistory) {
    var sectionId = root.getAttribute("data-section-id");
    if (!sectionId || root.getAttribute("data-collections-loading") === "true") return;

    var scrollY = window.scrollY;
    root.setAttribute("data-collections-loading", "true");
    showLoader(root);

    fetch(buildSectionUrl(href, sectionId), {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Collections section fetch failed");
        return response.text();
      })
      .then(function (html) {
        if (!replaceContent(root, html)) throw new Error("Collections section markup missing");
        if (pushHistory) {
          var cleanUrl = new URL(href, window.location.origin);
          cleanUrl.searchParams.delete("section_id");
          window.history.pushState({ collectionsPage: true }, "", cleanUrl.pathname + cleanUrl.search);
        }
        window.scrollTo(0, scrollY);
      })
      .catch(function () {
        window.location.href = href;
      })
      .finally(function () {
        root.removeAttribute("data-collections-loading");
        hideLoader(root);
      });
  }

  function onClick(event) {
    var root = event.target.closest(SELECTOR);
    if (!root) return;

    var link = event.target.closest(".collection-main__pagination a[href]");
    if (!link || !root.contains(link)) return;

    event.preventDefault();
    loadPage(root, link.href, true);
  }

  function onPopState() {
    document.querySelectorAll(SELECTOR).forEach(function (root) {
      loadPage(root, window.location.href, false);
    });
  }

  function init() {
    if (!document.querySelector(SELECTOR)) return;
    document.addEventListener("click", onClick);
    window.addEventListener("popstate", onPopState);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
